import Vue from 'vue'
import Router from 'vue-router'

// 表示する画面のページのインポートをここに記載すること
import Index from './components/home/index.vue'
import Welcome from './components/home/Welcome.vue'
import Home from './components/home/Home.vue'
import AppLogin from '@/components/AppLogin'
import AppSSOLogin from '@/components/AppSSOLogin'
import AppPasswordInitialization from '@/components/AppPasswordInitialization'
import AppPasswordForceChange from '@/components/AppPasswordForceChange'
import AppPatientSearch from '@/components/AppPatientSearch'
import AppPatientSearchSleep from '@/components/AppPatientSearchSleep'
import AppInspectionSearch from '@/components/AppInspectionSearch'
import AppInspectionView from '@/components/AppInspectionView'
import AppInspectionEdit from '@/components/AppInspectionEdit'
import AppPrescriptionView from '@/components/AppPrescriptionView'
import AppInspectionExecute from '@/components/AppInspectionExecute'
import AppPrescriptionEdit from '@/components/AppPrescriptionEdit'
import AppPrescriptionRefSleep from '@/components/AppPrescriptionRefSleep'
import AppAppointmentSearch from '@/components/AppAppointmentSearch'
import AppAppointmentEdit from '@/components/AppAppointmentEdit'
import AppPatientDetail from '@/components/AppPatientDetail'
import AppPatientDetailSleep from '@/components/AppPatientDetailSleep'
import AppUrgentList from '@/components/AppUrgentList'
import AppUrgentListResult from '@/components/AppUrgentListResult'
import AppUrgentEdit from '@/components/AppUrgentEdit'
import AppUrgentSchedule from '@/components/AppUrgentSchedule'
import AppSelectStaff from '@/components/AppSelectStaff'
import AppDomesticTravelSearch from '@/components/AppDomesticTravelSearch'
import AppDomesticTravel from '@/components/AppDomesticTravel'
import AppReportbatchPrintSearch from '@/components/AppReportbatchPrintSearch'
import AppDomesticTravelSearchResult from '@/components/AppDomesticTravelSearchResult'
import AppReportPrintHistory from '@/components/AppReportPrintHistory'
import AppPatientManagement from '@/components/AppPatientManagement'
import AppPatientManagementSleep from '@/components/AppPatientManagementSleep'
import AppPatientManagementEditPatient from '@/components/AppPatientManagementEditPatient'
import AppPatientManagementEditPatientSleep from '@/components/AppPatientManagementEditPatientSleep'
import AppUserManagement from '@/components/AppUserManagement'
import AppMasterMaint from '@/components/AppMasterMaint'
import AppMasterListProduct from '@/components/AppMasterListProduct'
import AppMasterListOffice from '@/components/AppMasterListOffice'
import AppRegularDisposablesSearch from '@/components/AppRegularDisposablesSearch'
import AppRegularDisposablesView from '@/components/AppRegularDisposablesView'
import AppSelectProduct from '@/components/AppSelectProduct'
import AppMasterListCustomer from '@/components/AppMasterListCustomer'
import AppHistorySearch from '@/components/AppHistorySearch'
import AppDispoDeliveryHistorySearch from '@/components/AppDispoDeliveryHistorySearch'
import AppPatientManagementEditConsentForm from '@/components/AppPatientManagementEditConsentForm'
import AppFraudPreventionMeasures from '@/components/AppFraudPreventionMeasures'
import AppPrescriptionHistoryModal from '@/components/AppPrescriptionHistoryModal'
import AppApiOperationHistorySearch from '@/components/AppApiOperationHistorySearch'
import AppDisasterSearch from '@/components/AppDisasterSearch'
import AppDisasterSearchResult from '@/components/AppDisasterSearchResult'
import AppDisasterEdit from '@/components/AppDisasterEdit'
import AppDisasterPatientList from '@/components/AppDisasterPatientList'
import AppDisasterSummary from '@/components/AppDisasterSummary'
import AppReportPreview from '@/components/AppReportPreview'

// import store from './store'

Vue.use(Router)

/*
// 認証状態チェック処理
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  console.log('not login. redirect to login...')
  next('/login')
}
*/

export default new Router({
  mode: 'history',
  routes: [
    // 共通画面
    {
      path: '/main',
      component: Index,
      children: [
        // ようこそ
        {
          name: 'Welcome',
          path: 'Welcome',
          component: Welcome
        },
        // HOME
        {
          name: 'Home',
          path: 'Home',
          component: Home
        },
        // 患者検索
        {
          name: 'AppPatientSearch',
          path: 'AppPatientSearch',
          component: AppPatientSearch
        },
        // 患者検索（睡眠）
        {
          name: 'AppPatientSearchSleep',
          path: 'AppPatientSearchSleep',
          component: AppPatientSearchSleep
        },
        // 患者詳細
        {
          name: 'AppPatientDetail',
          path: 'AppPatientDetail/:code',
          component: AppPatientDetail
        },
        // 患者詳細（睡眠）
        {
          name: 'AppPatientDetailSleep',
          path: 'AppPatientDetailSleep/:code',
          component: AppPatientDetailSleep
        },
        // 点検情報検索
        {
          name: 'AppInspectionSearch',
          path: 'AppInspectionSearch',
          component: AppInspectionSearch
        },
        // 点検情報参照
        {
          name: 'AppInspectionView',
          path: 'AppInspectionView/:productCode/:patientCode/:serial/:inspectionCode',
          component: AppInspectionView
        },
        // 点検情報編集
        {
          name: 'AppInspectionEdit',
          path: 'AppInspectionEdit/:productCode/:patientCode/:serial/:inspectionCode',
          component: AppInspectionEdit
        },
        // 点検値参照
        {
          name: 'AppPrescriptionView',
          path: 'AppPrescriptionView/:code/:productCode/:patientCode/:serialNumber/:appointmentCode/:completionDate',
          component: AppPrescriptionView
        },
        // 予約検索
        {
          name: 'AppAppointmentSearch',
          path: 'AppAppointmentSearch',
          component: AppAppointmentSearch
        },
        // 予約編集
        {
          name: 'AppAppointmentEdit',
          path: 'AppAppointmentEdit/:appointmentCode/:status',
          component: AppAppointmentEdit
        },
        // 患者対応
        {
          name: 'AppUrgentList',
          path: 'AppUrgentList',
          component: AppUrgentList
        },
        // 患者対応検索結果
        {
          path: 'AppUrgentListResult',
          component: AppUrgentListResult
        },
        // 患者対応登録
        {
          name: 'AppUrgentEdit',
          path: 'AppUrgentEdit/:inStatus/:patientCode/:code',
          component: AppUrgentEdit
        },
        // 待機当番管理
        {
          path: 'AppUrgentSchedule',
          component: AppUrgentSchedule
        },
        // 点検担当者検索
        {
          path: 'AppSelectStaff',
          component: AppSelectStaff
        },
        // 点検実施
        {
          name: 'AppInspectionExecute',
          path: 'AppInspectionExecute/:appointmentCode',
          component: AppInspectionExecute
        },
        // 指示値入力
        {
          name: 'AppPrescriptionEdit',
          path: 'AppPrescriptionEdit/:code/:productCode/:patientCode/:patientName/:serialNumber/:edit/:refer/:therapy',
          component: AppPrescriptionEdit
        },
        // 処方値参照（睡眠）
        {
          name: 'AppPrescriptionRefSleep',
          path: 'AppPrescriptionRefSleep',
          component: AppPrescriptionRefSleep
        },
        // 国内旅行対応
        {
          name: 'AppDomesticTravelSearch',
          path: 'AppDomesticTravelSearch',
          component: AppDomesticTravelSearch
        },
        // 国内旅行対応検索結果
        {
          path: 'AppDomesticTravelSearchResult',
          component: AppDomesticTravelSearchResult
        },
        // 国内旅行対応登録
        {
          name: 'AppDomesticTravel',
          path: 'AppDomesticTravel/:type/:domesticTravelCode',
          component: AppDomesticTravel
        },
        // 報告書一括印刷選択
        {
          name: 'AppReportbatchPrintSearch',
          path: 'AppReportbatchPrintSearch',
          component: AppReportbatchPrintSearch
        },
        // 報告書印刷履歴
        {
          name: 'AppReportPrintHistory',
          path: 'AppReportPrintHistory/:inspectionId/:printType',
          component: AppReportPrintHistory
        },
        // 報告書確認
        {
          name: 'AppReportPreview',
          path: 'AppReportPreview',
          component: AppReportPreview
        },
        // ユーザ管理
        {
          path: 'AppUserManagement',
          component: AppUserManagement
        },
        // 患者管理
        {
          name: 'AppPatientManagement',
          path: 'AppPatientManagement',
          component: AppPatientManagement
        },
        // 患者情報管理（睡眠）
        {
          name: 'AppPatientManagementSleep',
          path: 'AppPatientManagementSleep',
          component: AppPatientManagementSleep
        },
        // 患者編集
        {
          name: 'AppPatientManagementEditPatient',
          path: 'AppPatientManagementEditPatient/:code',
          component: AppPatientManagementEditPatient
        },
        // 患者情報編集（睡眠）
        {
          name: 'AppPatientManagementEditPatientSleep',
          path: 'AppPatientManagementEditPatientSleep/:code',
          component: AppPatientManagementEditPatientSleep
        },
        // マスタメンテナンス
        {
          path: 'AppMasterMaint',
          component: AppMasterMaint
        },

        // 品目一覧
        {
          path: 'AppMasterListProduct',
          component: AppMasterListProduct
        },
        // 営業所一覧
        {
          path: 'AppMasterListOffice',
          component: AppMasterListOffice
        },
        // 得意先一覧
        {
          path: 'AppMasterListCustomer',
          component: AppMasterListCustomer
        },
        // 連携履歴閲覧
        {
          path: 'AppApiOperationHistorySearch',
          component: AppApiOperationHistorySearch
        },
        // 操作履歴閲覧
        {
          path: 'AppHistorySearch',
          component: AppHistorySearch
        },
        // 消耗品発送履歴
        {
          path: 'AppDispoDeliveryHistorySearch',
          component: AppDispoDeliveryHistorySearch
        },
        // 同意書情報入力
        {
          name: 'AppPatientManagementEditConsentForm',
          path: 'AppPatientManagementEditConsentForm',
          component: AppPatientManagementEditConsentForm
        },
        // 消耗品発送
        {
          name: 'AppRegularDisposablesSearch',
          path: 'AppRegularDisposablesSearch',
          component: AppRegularDisposablesSearch
        },
        // 発送リスト
        {
          name: 'AppRegularDisposablesView',
          path: 'AppRegularDisposablesView',
          component: AppRegularDisposablesView
        },
        // 品目検索
        {
          path: 'AppSelectProduct',
          component: AppSelectProduct
        },
        // 不正防止対応検索
        {
          name: 'AppFraudPreventionMeasures',
          path: 'AppFraudPreventionMeasures',
          component: AppFraudPreventionMeasures
        },
        // 処方値変更履歴
        {
          name: 'AppPrescriptionHistoryModal',
          path: 'AppPrescriptionHistoryModal',
          component: AppPrescriptionHistoryModal
        },
        // 災害検索
        {
          name: 'AppDisasterSearch',
          path: 'AppDisasterSearch',
          component: AppDisasterSearch
        },
        // 災害検索結果
        {
          path: 'AppDisasterSearchResult',
          component: AppDisasterSearchResult
        },
        // 災害情報管理
        {
          name: 'AppDisasterEdit',
          path: 'AppDisasterEdit',
          component: AppDisasterEdit
        },
        // 災害患者一覧
        {
          path: 'AppDisasterPatientList',
          component: AppDisasterPatientList
        },
        // 災害情報サマリ
        {
          name: 'AppDisasterSummary',
          path: 'AppDisasterSummary',
          component: AppDisasterSummary
        },
      ]
    },
    // ログイン画面
    {
      path: '/',
      name: 'AppLogin',
      component: AppLogin
    },
    // SSO認証ログイン画面
    {
      path: '/SSOLogin',
      name: 'AppSSOLogin',
      component: AppSSOLogin
    },
    // パスワード初期化
    {
      path: '/pwdInit',
      name: 'AppPasswordInitialization',
      component: AppPasswordInitialization
    },
    // 初期パスワード強制変更
    {
      path: '/pwdchange',
      name: 'AppPasswordForceChange',
      component: AppPasswordForceChange,
      props: true
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router.js